import React, { Component } from 'react'

import React360Viewer from '../360/React360Viewer';
import { handleZoomOnThreeSixty } from '../../utils/util';

class Test360 extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount(){
        handleZoomOnThreeSixty();
    }
    
    render() {
        // var foo = new Array(36);
        let cdn_prefix = "";
        if (Liferay.ThemeDisplay.getLayoutURL().includes('www.boschautoparts.com"')) {
            cdn_prefix = 'https://test-cdn-qa-private-endpoint.azureedge.net/autopartqausstgcdntest/Prod'
        } else {
            cdn_prefix = 'https://test-cdn-qa-private-endpoint.azureedge.net/autopartqausstgcdntest'
        }
        return (
            <div className="Test360">
                <React360Viewer
                    paddingIndex="true"
                    amount={this.props.amount}
                    imagePath={cdn_prefix + '/Assets/360/' + this.props.identifier}
                    fileName={this.props.identifier.substring(0, 10) + '0{index}.jpg'}
                    spinReverse={true}
                />
            </div>
        )
    }
}

export default Test360
